import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';

import { useMemo, useState } from 'react';

import { Document, Page } from 'react-pdf';

import 'pdfjs-dist/build/pdf.worker.min.mjs';

import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import { ReactComponent as PrevIcon } from 'common/assets/images/left-chevron.svg';
import { ReactComponent as NextIcon } from 'common/assets/images/right-chevron-carosuel.svg';
import { DEFAULT_TENANT_ID } from 'common/constants/index';
import localStorageWrapper from 'common/loginUtils/local-storage-wrapper';
import storageWrapper from 'common/loginUtils/storage-wrapper';
import { getHeader } from 'common/utils/utilFunctions';

import { getDownloadFileUrl } from '../api';
import { IPDFDisplayDrawerProps } from '../api/type-def';

import styles from './PDFDisplayDrawer.module.scss';

const PDFDisplayDrawer = (props: IPDFDisplayDrawerProps) => {
	const { drawerCloseIconColor } = styles;

	const { fileName, pageNumber, handleClickClose } = props;

	const [numPages, setNumPages] = useState<number>();
	const [page, setPage] = useState<number>(pageNumber);
	const [isLoading, setIsLoading] = useState<boolean>(true);

	const header = useMemo(() => {
		const token = storageWrapper.getStorageItem('access-token');
		const acessToken = `Bearer ${token}`;
		const tenantToken = 'X-TENANT-ID';
		const tenantId =
			localStorageWrapper.getStorageItem('tenantId') || DEFAULT_TENANT_ID;
		return {
			httpHeaders: {
				...getHeader(),
				Authorization: acessToken,
				[tenantToken]: tenantId,
			},
		};
	}, []);

	const onDocumentLoadSuccess = ({ numPages }: any) => {
		setNumPages(numPages);
		setIsLoading(false);
	};

	return (
		<Grid
			display="flex"
			justifyContent="space-between"
			flexDirection="column"
			className={styles['detailed-container']}
			data-testid="groups-container"
		>
			<Box className={styles['pdf-display-header']}>
				<div
					className={styles['groups-text-background']}
					data-testid="pdf-top-div"
				>
					<Stack
						direction="row"
						justifyContent="space-between"
						spacing={2}
						data-testid="close-button-stack"
					>
						<Typography className={styles['source-heading']}>
							{`${fileName} - Page ${pageNumber}`}
						</Typography>
						<IconButton
							size="large"
							onClick={handleClickClose}
							data-testid="close-groups-btn"
							className={styles['close-icon']}
						>
							<DrawerClose fill={drawerCloseIconColor} />
						</IconButton>
					</Stack>
				</div>
			</Box>
			<Box className={styles['pdf-display-content']}>
				<Document
					file={getDownloadFileUrl(`${fileName}.pdf`)}
					options={header}
					onLoadSuccess={onDocumentLoadSuccess}
				>
					<Page
						className={styles['pdf-page']}
						pageNumber={page}
						renderTextLayer={false}
						renderAnnotationLayer={false}
					/>
				</Document>
			</Box>
			{!isLoading && (
				<Box className={styles['pdf-display-footer']}>
					<Stack
						direction="row"
						justifyContent="space-around"
						alignItems="center"
					>
						<IconButton
							data-testid="prev-icon"
							onClick={() => setPage(page - 1)}
							className={styles['common-table-icon-button-prev']}
							disabled={page === 1}
						>
							<PrevIcon />
						</IconButton>
						<Box>{`${page} of ${numPages}`}</Box>
						<IconButton
							aria-label="delete"
							data-testid="next-icon"
							onClick={() => setPage(page + 1)}
							className={styles['common-table-icon-button-next']}
							disabled={page === numPages}
						>
							<NextIcon />
						</IconButton>
					</Stack>
				</Box>
			)}
		</Grid>
	);
};

export default PDFDisplayDrawer;
